import PageWrap from "components/PageWrap/PageWrap";
import { DigitalSizeEditor } from "components/GigitalSizeEditor/DigitalSizeEditor";
import { Redirect, Route, Switch } from "react-router-dom";
import SetupBar from "components/SetupBar/SetupBar";
import _ from "lodash";
import { useMemo } from "react";
import { PrintServiceEditor } from "components/PrintServiceEditor/PrintServiceEditor";
import { DigitalServiceEditor } from "components/DigitalServiceEditor/DigitalServiceEditor";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { PrintSizeEditor } from "components/PrintSizeEditor/PrintSizeEditor";
import UserManagementEditor from "components/UserManagementEditor/UserManagementEditor";
import ApproverEditor from "components/ApproverEditor/ApproverEditor";
import { MediaAgencyEditor } from "components/MediaAgencyEditor/MediaAgencyEditor";

const SetupPage = ({ match, location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  // Expected split input e.g. "/setup/digital-sizes" -> currentPageKey === "digital-sizes"
  const currentPageKey = useMemo(() => _.split(location.pathname, "/")[2], [location.pathname]);

  return (
    <PageWrap page="setup" t={t}>
      <h1>{t("pages_setup")}</h1>
      <div className="page-nav">
        <SetupBar currentPageKey={currentPageKey} />
      </div>
      <div key={location.key}>
        <Switch location={location}>
          <Route
            exact
            path={match.path + "/digital-sizes"}
            render={() => <DigitalSizeEditor dispatch={dispatch} t={t} />}
          />
          <Route
            exact
            path={match.path + "/digital-services"}
            render={() => <DigitalServiceEditor dispatch={dispatch} t={t} />}
          />
          <Route
            exact
            path={match.path + "/print-sizes"}
            render={() => <PrintSizeEditor dispatch={dispatch} t={t} />}
          />
          <Route
            exact
            path={match.path + "/print-services"}
            render={() => <PrintServiceEditor dispatch={dispatch} t={t} />}
          />
          <Route
            exact
            path={match.path + "/user-management"}
            render={() => <UserManagementEditor />}
          />
          <Route
            exact
            path={match.path + "/approvers"}
            render={() => <ApproverEditor dispatch={dispatch} t={t} />}
          />
          <Route
            exact
            path={match.path + "/media-agencies"}
            render={() => <MediaAgencyEditor dispatch={dispatch} t={t} />}
          />
          <Redirect to={match.path + "/digital-sizes"} />
        </Switch>
      </div>
    </PageWrap>
  );
};

export default SetupPage;
